"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _slugify = _interopRequireDefault(require("slugify"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _Heading = _interopRequireDefault(require("../heading/Heading"));

var _Flex = _interopRequireDefault(require("../flex/Flex"));

var _Inset = _interopRequireDefault(require("../inset/Inset"));

var _Typography = _interopRequireDefault(require("../typography/Typography"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcQuickNav = function DxcQuickNav(_ref) {
  var title = _ref.title,
      links = _ref.links;
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var colorsTheme = (0, _useTheme["default"])();
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.quickNav
  }, /*#__PURE__*/_react["default"].createElement(QuickNavContainer, null, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    direction: "column",
    gap: "0.5rem"
  }, /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
    level: 4,
    text: title || translatedLabels.quickNav.contentTitle
  }), /*#__PURE__*/_react["default"].createElement(ListColumn, null, links.map(function (link) {
    var _link$links;

    return /*#__PURE__*/_react["default"].createElement("li", {
      key: link.label
    }, /*#__PURE__*/_react["default"].createElement(_Inset["default"], {
      space: "0.25rem"
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, /*#__PURE__*/_react["default"].createElement(Link, {
      href: "#".concat((0, _slugify["default"])(link === null || link === void 0 ? void 0 : link.label, {
        lower: true
      }))
    }, link === null || link === void 0 ? void 0 : link.label), /*#__PURE__*/_react["default"].createElement(ListSecondColumn, null, (_link$links = link.links) === null || _link$links === void 0 ? void 0 : _link$links.map(function (sublink) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: sublink.label
      }, /*#__PURE__*/_react["default"].createElement(_Inset["default"], {
        horizontal: "0.5rem"
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, /*#__PURE__*/_react["default"].createElement(Link, {
        href: "#".concat((0, _slugify["default"])(link === null || link === void 0 ? void 0 : link.label, {
          lower: true
        }), "-").concat((0, _slugify["default"])(sublink === null || sublink === void 0 ? void 0 : sublink.label, {
          lower: true
        }))
      }, sublink === null || sublink === void 0 ? void 0 : sublink.label))));
    })))));
  })))));
};

var QuickNavContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  border-left: 2px solid ", ";\n"])), function (props) {
  return props.theme.paddingTop;
}, function (props) {
  return props.theme.paddingBottom;
}, function (props) {
  return props.theme.paddingLeft;
}, function (props) {
  return props.theme.paddingRight;
}, function (props) {
  return props.theme.dividerBorderColor;
});

var ListColumn = _styledComponents["default"].ul(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n"])));

var ListSecondColumn = _styledComponents["default"].ul(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n"])));

var Link = _styledComponents["default"].a(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  text-decoration: none;\n  font-size: ", ";\n  font-family: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  color: ", ";\n  display: block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: fit-content;\n  max-width: 100%;\n\n  &:hover {\n    color: ", ";\n  }\n  &:focus {\n    outline-color: ", ";\n    outline-style: ", ";\n    outline-width: ", ";\n    border-radius: ", ";\n  }\n"])), function (props) {
  return props.theme.fontSize;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontStyle;
}, function (props) {
  return props.theme.fontWeight;
}, function (props) {
  return props.theme.fontColor;
}, function (props) {
  return props.theme.hoverFontColor;
}, function (props) {
  return props.theme.focusBorderColor;
}, function (props) {
  return props.theme.focusBorderStyle;
}, function (props) {
  return props.theme.focusBorderThickness;
}, function (props) {
  return props.theme.focusBorderRadius;
});

var _default = DxcQuickNav;
exports["default"] = _default;